import InlineCommentButtonView from 'backbone/story/views/comments/inline_comment_button_view.js'
import Annotator from 'lib/image_annotator/components/annotator.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'

export default class ImageCommentView extends Backbone.View
  events:
    "click .js-toggle-comment-visibility" : "toggleCommentVisibility"
    "collapsible:toggled"                 : "showCommentButton"
    "click .dropdown-container"           : "exitActiveModes"

  initialize: (options) ->
    @image = true
    @options = options
    @asset = options.asset
    @permittedToComment = window.story.permitted_to_comment || false
    @inlineCommentUtils = new InlineCommentUtils()
    @$commentPlaceholder = $(".js-comment-placeholder")
    @_setupCommentCollectionAndListeners()
    @commentViewMediator = page.get("commentViewMediator")
    @commentViewMediator.registerView(this)
    @$imgContainer = @$el.find(".js-images-container")
    @_initCommentsAndAnnotator()

  toggleCommentVisibility: ->
    return unless @annotator

    if @annotator.isActivated()
      @annotator.fire("deactivateAnnotator")
      @$el.addClass("hide-image-comments")
    else
      @annotator.fire("activateAnnotator")
      @$el.removeClass("hide-image-comments")

  exitActiveModes: ->
    @_closeActive() if @annotator.isActivated()
    @commentCollection.removeActive()
    @commentViewMediator.removeCommentView()
    @commentViewMediator.removeCommentForm()

  remove: (removeEl = false) ->
    @_teardownAnnotator()
    @commentViewMediator.unregisterView(this)
    @commentButton.remove()
    @stopListening()
    @$el.remove() if removeEl

  showCommentButton: (e) =>
    return unless @permittedToComment
    e.stopPropagation() if e?
    return if !(@commentButton == null || typeof @commentButton == "undefined")
    return unless @annotator.isActivated()
    if ($collapsible = @$el.find(".js-collapsible-container")).exists()
      return unless $collapsible.hasClass("active")

    @commentButton = new InlineCommentButtonView()
      .render()
      .$el

    @$el.find(".actions").prepend @commentButton

    @commentButton.on("mouseup", @enterAddingAnnotation)
    @commentButton.on("click", (e) -> e.stopPropagation())

  showComment: (commentData) =>
    @toggleCommentVisibility() unless @annotator.isActivated()

    commentModel = @commentCollection.get(commentData.id)
    @commentViewMediator.showInlineComment
      view: this
      comment: commentModel
      offset: @topOffset(commentData.shapeOffsetTop)

  topOffset: (shapeOffset) ->
    try
      @$imgContainer.offset().top - $(".js-comment-placeholder").offset().top + shapeOffset
    catch
      0

  enterAddingAnnotation: =>
    return if @commentViewMediator.commentInProgress()
    @commentCollection.removeActive()
    @commentViewMediator.removeCommentView()
    @commentViewMediator.removeCommentForm()
    @annotator.fire("addingAnnotation")
    @annotator.fire("activateAnnotator")

    @$el.removeClass("hide-image-comments")
    @$el.addClass("active-new-comment")
    @$el.find(".dropdown-container").removeClass("active")

  ### MEDIATOR CALLBACKS ###

  onViewOpen: (comment) ->
    @annotator.fire("setActiveAnnotation", comment.toImageAnnotation())
    @$el.find(".dropdown-container").removeClass("active")

  onViewClose: () ->
    @_closeActive()

  onCommentFormClose: () ->
    @_closeActive()

  openCommentView: (comment) ->
    @_openAnnotation(comment)

  commentInView: (comment) ->
    comment.belongsToAsset(@asset)

  renderNewCommentForm: (event) ->
    @commentViewMediator.renderCommentForm
      view: this
      offset: @topOffset(event.detail.shapeOffsetTop)
      image: true
      shape: event.detail.shapeData
      assetId: @asset.get("asset_id")

  _initCommentsAndAnnotator: () =>
    @comments = @commentCollection.forImage(@asset)
    @_initAnnotator()
    @showCommentButton()

  _initAnnotator: () ->
    @$imgContainer.on("click", (e) -> e.stopPropagation())

    @annotator = new Annotator(
      imgContainer: @$imgContainer,
      annotations: @comments
    )

    @annotator.on("newShapeDrawn", (event) =>
      @annotator.fire("lockShape")
      @renderNewCommentForm(event)
    )

    @annotator.on("clickDuringLockedState", (e) =>
      if !@commentViewMediator.commentInProgress()
        @commentViewMediator.removeCommentForm()
        @_closeActive()
    )

    @annotator.on("annotationOpened", (e) =>
      annotation = e.detail
      @$el.find(".js-collapsible-container").addClass("active")
      @showComment(annotation)
    )

  _teardownAnnotator: () ->
    @$imgContainer.unbind("click", (e) -> e.stopPropagation())

    @annotator.off("newShapeDrawn")
    @annotator.off("clickDuringLockedState")
    @annotator.off("annotationOpened")

    @annotator.teardown()
    @annotator = null

  _setupCommentCollectionAndListeners: ->
    @commentCollection = page.get("storyComments")
    @listenTo(@commentCollection, "change:resolved", @_onInlineCommentResolved)
    @listenTo(@commentCollection, "add", @_onInlineCommentCreated)

  _onInlineCommentResolved: (comment, event) =>
    if comment.isImage() && comment.belongsToAsset(@asset)
      @annotator.fire("destroyAnnotation", comment.toImageAnnotation())

  _onInlineCommentCreated: (comment) =>
    if comment.isImage() && comment.belongsToAsset(@asset)
      comment = comment.toImageAnnotation()
      @annotator.fire("newAnnotation", comment)

  _openAnnotation: (comment, event) =>
    return if @commentViewMediator.view == this
    $.when(
      @$el.find(".collapsible-container").addClass("active")
    ).done(() =>
      @annotator.fire("openAnnotation", comment.toImageAnnotation())
    )

  _closeActive: () =>
    @annotator.fire("unlockShape")
    @annotator.fire("cancelAddingAnnotation") if @annotator.inAnnotationMode()
    @annotator.fire("closeActiveAnnotation")

    $(".active-new-comment").removeClass("active-new-comment")



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/image_comment_view.js.coffee